<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismissModal()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'PRODUCT.account.title' | translate }}
    </ion-title>
  </ion-toolbar>
  <ion-toolbar>
    <ion-item class="full-width ion-item-no-padding" color="light" lines="none" *ngIf="productId">
      <ion-label>
        <div *ngIf="productId">
          <ion-img class="product-img ion-margin" [src]="'./assets/wedding/img/product/account/' + productId + '.svg'"></ion-img>
        </div>
        <div class="ion-text-center">
          {{ 'PRODUCT.account.' + productId + '.short' | translate }}
        </div>
      </ion-label>
    </ion-item>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding-vertical" color="tertiary">
  <div class="content-div">
    <div class="ion-text-center ion-margin-vertical">
      <ion-text class="font-underline font-bold">{{ 'PRODUCT.account.highlight' | translate }}</ion-text>
    </div>
    <div *ngIf="productId === 'wedding_account_full'">
      <ion-item class="font-14" color="tertiary" lines="none" *ngFor="let number of [1,2,3,4]">
        <ion-icon slot="start" name="star-outline"></ion-icon>
        <ion-text>{{ 'PRODUCT.account.wedding_account_full.detail.' + number | translate }}</ion-text>
      </ion-item>
    </div>
    <div *ngIf="productId === 'wedding_account_app'">
      <ion-item class="font-14" color="tertiary" lines="none" *ngFor="let number of [1,2]">
        <ion-icon slot="start" name="star-outline"></ion-icon>
        <ion-text>{{ 'PRODUCT.account.wedding_account_app.detail.' + number | translate }}</ion-text>
      </ion-item>
    </div>
    <div *ngIf="productId === 'wedding_account_web'">
      <ion-item class="font-14" color="tertiary" lines="none" *ngFor="let number of [1,2,3]">
        <ion-icon slot="start" name="star-outline"></ion-icon>
        <ion-text>{{ 'PRODUCT.account.wedding_account_web.detail.' + number | translate }}</ion-text>
      </ion-item>
    </div>
    <div class="ion-text-center ion-margin-vertical">
      <ion-text class="font-underline font-bold">{{ 'PRODUCT.account.general' | translate }}</ion-text>
    </div>
    <ion-item class="font-14" color="tertiary" lines="none" *ngFor="let number of [1,2,3,4,5,6]">
      <ion-icon slot="start" name="star-outline"></ion-icon>
      <ion-text>{{ 'PRODUCT.account.detail.' + number | translate }}</ion-text>
    </ion-item>
  </div>
</ion-content>
<ion-footer *ngIf="purchaseMode">
  <ion-toolbar>
    <div class="content-div">
      <ion-button class="ion-margin" expand="block" (click)="selectProduct()">
        {{ 'BTN.select' | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>